import type React from 'react';
import GalleryPageTabComponent from 'src/Administration/PageContent/PageContentGallery/GalleryPageTab/GalleryPageTab';
import PreviewTabs from 'src/components/Tabs/PreviewTabs/PreviewTabs';
import TabPane from 'src/components/Tabs/TabPane/TabPane';
import styles from './PageContentGalleryStyles';

const GalleryPageComponent: React.FC = () => {
  const classes = styles();
  return (
    <div className={classes.tabWrapper}>
      <PreviewTabs defaultTab="Gallery Page Metadata">
        <TabPane name="Gallery Page Metadata" key="1">
          <GalleryPageTabComponent />
        </TabPane>
      </PreviewTabs>
    </div>
  );
};

export default GalleryPageComponent;
